import React, { useContext, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { ContextualSaveBar } from "@shopify/app-bridge-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../../components/global/appContext";
import lmsAPI from "../../../../services/lmsAPI";
import Form from "./Form";

export default function LocationNew(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);
  const queryClient = useQueryClient();

  // Fetch initial data for new locations (fields, containers, etc.)

  const [location, setLocation] = useState(null);
  const [created, setCreated] = useState(false);
  const [errors, setErrors] = useState({});

  // Update location state when API data arrives

  async function createLocationRequest(locationParams) {
    const res = await lmsAPI.post("/locations", {
      location: locationParams,
    });
    return res.data;
  }
  const createLocation = useMutation(createLocationRequest, {
    onSuccess: (data) => {
      setLocation(data);
      queryClient.setQueryData(["locations", data.id], data);
      appContext.setMessage(t("location.validation.createSuccess"));
      setErrors({});
      setCreated(true);
    },
    onError: (error) => {
      console.error(error.response);
      const baseError =
        error.response.data.base && error.response.data.base.join(" ");
      appContext.setMessage(baseError || t("location.validation.checkFields"), true);
      setErrors(error.response.data);
      if (error.response.data.message) {
        appContext.setMessage(error.response.data.message);
      }
    },
  });

  if (created) {
    return (
      <>
        <ContextualSaveBar visible={false} leaveConfirmationDisable />
        <Navigate
          to={"/places/locations/" + location.id}
          state={{ message: t("location.validation.createSuccess") }}
        />
      </>
    );
  }

  return (
    <Form
      title={t("location.form.title")}
      location={location}
      setLocation={setLocation}
      saveAction={{
        onAction: () => createLocation.mutate(location),
        loading: createLocation.isLoading,
      }}
      loading={createLocation.isLoading}
      errors={errors}
    />
  );
}
